<template>

  <v-navigation-drawer
    class="back"
    style="cursor: default"
    :width="sidebarWidth"
    :mini-variant.sync="leftBarMini"
    :mini-variant-width="minWidth"
    permanent
    stateless
    floating
    disable-resize-watcher
    :data-testid="$options.name + '__navigation-drawer'"
  >

    <scroll-area>

      <template slot="header">
      </template>

      <template slot="body">

        <v-layout column fluid fill-height ma-0 pa-0 @click.stop="" class="drawer" style="position: relative;">

          <loader
            :show="isEdit"
            :circle="false"
            :cursor="'no-drop'"
          />

          <v-expansion-panel 
            expand
            focusable
            left
            :data-testid="$options.name + '__expansion-panel'"
          >
            <v-expansion-panel-content 
              v-for="(item, index) in getPages" :key="'pages_' + index" 
              :style="$store.state.structure.current.tab == item ? 'background-color: white' : 'background-color: white'"
              expand-icon=""
              :data-testid="$options.name + '__expansion-panel-content__' + 'pages_' + item"
              @click="listClickHandler(item)"  
            > 

              <template v-slot:header  >
                <v-flex shrink pr-2 pt-1 @click.stop="listClickHandler(item)">
                    <svg-icon
                        :color="$store.state.structure.current.tab == item ? 'black' : 'black'"
                        :name="item"
                        width="28"
                        :data-testid="$options.name + '__expansion-panel-content__' + 'btn__' + item"
                        @click.stop="listClickHandler(item)"
                      />

                </v-flex>
                <span v-show="!leftBarMini" class="body-1 text-uppercase" @click="listClickHandler(item)" :data-testid="$options.name + '__expansion-panel-content__' + 'span__' + item">{{ $t(item) }}</span>
              </template>

              <v-card>
                <v-layout fill-height style="overflow-x: auto; background-color: #F3F3F3" pl-1 >
                  <v-layout column v-if="item == 'objects'" v-show="!leftBarMini" fill-height>
                    <v-layout justify-center align-center style="border-top: solid 1px #DCDCDC" pr-1>
                      <v-layout justify-space-around align-center >

                        <v-flex xs11>
                          <v-layout justify-end align-center >
                            <v-flex xs6>
                              <v-btn :color="treeShowPhysical ?'primary' : 'white'" 
                                depressed 
                                small
                                block 
                                :outline="treeShowPhysical"
                                :data-testid="$options.name + '__expansion-panel-content__' + 'equipment__btn'"
                                @click="() => treeShowType('equipment')" 
                                style="height: 20px;"
                              >
                                <span v-if="treeShowPhysical" class="caption" px-2>{{$t('equipment')}}</span>
                                <span v-if="!treeShowPhysical" class="caption secondary--text" px-2>{{$t('equipment')}}</span>
                              </v-btn>
                            </v-flex>
                            <v-flex xs1>

                            </v-flex>
                            <v-flex xs6>
                              <v-btn :color="treeShowServices ?'primary' : 'white'" 
                                depressed 
                                small 
                                block 
                                :outline="treeShowServices"
                                :data-testid="$options.name + '__expansion-panel-content__' + 'services__btn'"
                                @click="() => treeShowType('services')" 
                                style="height: 20px"
                              >
                                <span v-if="treeShowServices" class="caption">{{$t('services')}}</span>
                                <span v-if="!treeShowServices" class="caption secondary--text">{{$t('services')}}</span>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                      </v-layout>

                      <v-flex shrink>
                        <v-tooltip bottom color="primary">
                          <v-btn icon small outline class="primary font-weight-medium" style="height: 20px; width: 20px;" slot="activator" 
                            :data-testid="$options.name + '__expansion-panel-content__' + 'root_element__btn'"
                            @click="() => createRootElement()"
                            >
                            <svg-icon
                              :color="'primary'"
                              :name="'add'"
                              width="18"
                            />
                          </v-btn>
                          <span>{{ $t('create root element') }}</span>
                        </v-tooltip>
                      </v-flex>
                    
                    </v-layout>
                    
                    <topology-tree
                      v-if="item == 'objects'" 
                      v-show="!leftBarMini"
                      :opened="opened"
                      :hideClass="getHideClass"
                      :treeShow="getTreeShow"
                    />
                  </v-layout>

                  <v-layout column v-if="item == 'settings'" fill-height>
                    <configuration-tree
                      v-if="item == 'settings'" 
                      v-show="!leftBarMini"
                      :opened="opened"
                    />    
                  </v-layout>    
                </v-layout>                 
              </v-card>          
            </v-expansion-panel-content>           
          </v-expansion-panel>
        </v-layout>

      </template>

      <template slot="footer">
      </template>

    </scroll-area>

  </v-navigation-drawer>

</template>

<script lang="ts">
import Vue from 'vue'
import loader from '@/nms/components/partials/loader.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import TopologyTree from '@/nms/components/tree/topology-tree.vue'
import ConfigurationTree from '@/nms/pages/configuration/configuration-tree.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface CurrentState {
  page: string
}

interface TreeNode {
  $id?: string
  id?: string
  name?: string
  cls?: string
  type?: string
  [key: string]: any
}

interface UserData {
  role?: 'administrator' | 'manager' | 'operator' | 'inform_secur_user'
  [key: string]: any
}

interface RoleFilter {
  administrator: string[]
  manager: string[]
  operator: string[]
  inform_secur_user: string[]
}

export default Vue.extend({
  name: 'SIDEBAR',

  components: {
    loader,
    scrollArea,
    TopologyTree,
    ConfigurationTree,
    svgIcon
  },

  props: {
    sidebarWidth: {
      type: [Number, String] as Vue.PropType<number | string>,
      default: () => 400
    },
    minWidth: {
      type: [Number, String] as Vue.PropType<number | string>,
      default: () => 60
    },
    leftBarMini: {
      type: Boolean,
      default: () => false
    },
  },

  data(): {
    current: CurrentState
    pages: string[]
    opened: any[]
    physicalTreeActive: TreeNode | null
    settingsTreeActive: TreeNode | null
    treeShowPhysical: boolean
    treeShowServices: boolean
  } {
    return {
      current: { page: 'dashboard' },
      pages: [],
      opened: [],
      physicalTreeActive: null,
      settingsTreeActive: null,
      treeShowPhysical: true,
      treeShowServices: false,
    }
  },

  computed: {
    isEdit(): boolean {
      return this.$store.getters.getEditMode
    },

    checkInterfaceLoaded(): boolean {
      return this.$store.getters.getInterfacLoaded
    },

    getCurrentUser(): UserData | null {
      return this.$store.getters.getCurrentUser
    },

    getPages(): string[] {
      const currentUser = this.getCurrentUser
      if (!currentUser) {
        return this.$store.getters.getPages
      }

      const filter: RoleFilter = {
        administrator: ['reports'],
        manager: ['reports'],
        operator: ['reports', 'settings'],
        inform_secur_user: ['reports']
      }

      const userRole = currentUser.role
      const excludedPages = filter[userRole as keyof RoleFilter] || []

      return this.$store.getters.getPages.filter((page: string) => {
        return !excludedPages.includes(page)
      })
    },

    getTreeShow(): string[] {
      let treeShow
      if (!this.treeShowPhysical) {
        treeShow = 'service'
      }
      if (!this.treeShowServices) {
        treeShow = 'physical'
      }
      return treeShow
    },

    getHideClass(): string[] {
      const hideClass: string[] = []
      if (!this.treeShowPhysical) {
        hideClass.push('location', 'cabinet', 'device', 'module')
      }
      if (!this.treeShowServices) {
        hideClass.push('service')
      }
      return hideClass
    },
  },

  watch: {
    '$store.state.structure.current.tab': {
      handler(newVal: string): void {
        if (this.current.page === newVal) return
        this.current.page = newVal
      },
      deep: true
    },

    '$store.state.devices.treeActive': {
      handler(newVal: TreeNode[]): void {
        console.log(this.$options.name, 'WATCH', '$store.state.devices.treeActive', newVal)
        if (!newVal?.length) return
        if (!this.checkInterfaceLoaded) return

        const newActive = newVal[0]
        if (this.physicalTreeActive && newActive && this.physicalTreeActive.$id !== newActive.$id) {
          this.$store.dispatch('activeDevice', null)
        }

        if (newVal.length && this.$store.state.structure.current.tab !== 'objects') {
          this.$store.dispatch('pageChange', 'objects')
          this.$router.push({ name: 'objects' })
        }

        this.physicalTreeActive = newActive
        this.activeHandler('WATCH $store.state.devices.treeActive', newActive)
      },
      deep: true
    },

    '$store.state.structure.settings.treeActive': {
      handler(newVal: TreeNode[]): void {
        console.log('WATCH', this.$options.name, '$store.state.structure.settings.treeActive', newVal)
        if (!newVal?.length) return
        if (!this.checkInterfaceLoaded) return

        const newActive = newVal[0]
        if (newVal.length && this.$store.state.structure.current.tab !== 'settings') {
          this.$store.dispatch('pageChange', 'settings')
          this.$router.push({ name: 'settings' })
        }

        this.settingsTreeActive = newActive
        this.activeHandler('WATCH $store.state.structure.settings.treeActive', newActive)
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    const panels = document.getElementsByClassName('v-expansion-panel__header')
    for (let i = 0; i < panels.length; i++) {
      const panel = panels[i] as HTMLElement
      panel.addEventListener('click', this.parentListClickHandler)
    }
  },

  methods: {
    testmethod(): void {
      // Метод предназначен для переопределения при необходимости
    },

    setup(): void {
      this.activeHandler('setup')
      this.testmethod()
    },

    async activeHandler(caller?: string, val?: TreeNode): Promise<void> {
      console.log(this.$options.name, 'activeHandler', 'CALLER:', caller, 'val', val)
      this.directRoute(val, caller)
    },

    async directRoute(val?: TreeNode, caller?: string): Promise<void> {
      console.log(this.$options.name, 'DIRECTROUTE', 'CALLER:', caller, 'newVal', val)

      const currentModule = this.$store.state.structure.current.module
      const currentTab = this.$store.state.structure.current.tab

      if (!val) {
        console.log(this.$options.name, 'DIRECTROUTE', '!val')
        try {
          if (!currentTab) {
            this.$store.dispatch('pageChange', 'dashboard')
          } else {
            this.$router.push({ name: currentTab })
          }
          await this.$store.dispatch('activeCabinet', null)
          await this.$store.dispatch('activeDevice', null)
          return
        } catch (error) {
          console.log(this.$options.name, 'directRoute', 'error', 'val', val, error)
        }
      }

      if (currentModule === 'common') {
        const cls = val.cls

        if (cls === 'service') {
          try {
            await this.$store.dispatch('activeSidebar', cls)
            await this.$store.dispatch('activeCabinet', null)
            if (this.$router.currentRoute.name !== cls) {
              const name = `${currentTab}_${cls}`
              this.$router.push({ name })
            }
            return
          } catch (error) {
            console.log(this.$options.name, 'directRoute', 'error', 'val', val, error)
          }
        }

        if (cls === 'location') {
          try {
            await this.$store.dispatch('activeSidebar', cls)
            await this.$store.dispatch('activeCabinet', null)
            const type = val.type
            if (type && this.$router.currentRoute.name !== type) {
              const name = `${currentTab}_${type}`
              this.$router.push({ name })
            }
            return
          } catch (error) {
            console.log(this.$options.name, 'directRoute', 'error', 'val', val, error)
          }
        }

        if (cls === 'cabinet') {
          try {
            await this.$store.dispatch('activeSidebar', cls)
            await this.$store.dispatch('activeCabinet', val)
            this.$store.dispatch('activeDevice', null)
            const name = `${currentTab}_${cls}`
            this.$router.push({ name })
            return
          } catch (error) {
            console.log(this.$options.name, 'directRoute', 'error', 'val', val, error)
          }
        }

        if (cls === 'device' || cls === 'module') {
          try {
            await this.$store.dispatch('activeSidebar', cls)
            const name = `${currentTab}_device`
            if (this.$router.currentRoute.name !== name) {
              this.$router.push({ name })
            }
            await this.$store.dispatch('activeCabinet', null)
            this.$store.dispatch('activeDevice', val)
            return
          } catch (error) {
            console.log(this.$options.name, 'directRoute', 'error', 'val', val, error)
          }
        }
      }
    },

    parentListClickHandler(e: MouseEvent): void {
      console.log(this.$options.name, 'parentListClickHandler', (e.target as HTMLElement).firstChild)
      const target = e.target as HTMLElement
      if (target.firstChild) {
        (target.firstChild as HTMLElement).dispatchEvent(new Event('click'))
      }
    },

    listClickHandler(val: string): void {
      console.log(this.$options.name, 'listClickHandler', val)
      this.leftBarMini = false
      this.$store.dispatch('pageChange', val)
      this.$router.push({ name: val })
    },

    createRootElement(): void {
      this.$emit('createRootElement')
    },

    treeShowType(val: string): void {
      if (val === 'equipment') {
        this.treeShowPhysical = true
        this.treeShowServices = false
      }
      if (val === 'services') {
        this.treeShowPhysical = false
        this.treeShowServices = true
      }
    },
  },
})
</script>

<style lang="stylus">

aside.app-drawer.v-navigation-drawer
  margin-top 70px !important

</style>

<style scoped>

.selectes-class {
  background-color: red;
}

.drawer {
  border-right: solid 1px #9F9F9F
}

</style>
